module.exports = __webpack_public_path__ + "img/image-collection-sliding-overlays-cjdr.192887cf.jpg";